import * as React from 'react'
import clsx from 'clsx'

export interface RippleClasses {
  /** Styles applied to the root element. */
  root?: string
  /** Styles applied to the internal `Ripple` components `ripple` class. */
  ripple?: string
  /** Styles applied to the internal `Ripple` components `rippleVisible` class. */
  rippleVisible?: string
  /** Styles applied to the internal `Ripple` components `ripplePulsate` class. */
  ripplePulsate?: string
  /** Styles applied to the internal `Ripple` components `child` class. */
  child?: string
  /** Styles applied to the internal `Ripple` components `childLeaving` class. */
  childLeaving?: string
  /** Styles applied to the internal `Ripple` components `childPulsate` class. */
  childPulsate?: string
}

export interface RippleProps {
  /**
   * className
   */
  className?: string
  /**
   * @ignore
   */
  classes?: RippleClasses
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: boolean
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: number
  /**
   * Vertical position of the ripple center.
   */
  rippleY: number
  /**
   * Diameter of the ripple.
   */
  rippleSize: number
  /**
   * exit delay
   */
  timeout: number
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited?: () => any
  /**
   * @ignore - injected from TransitionGroup
   */
  in?: Boolean
}

export function Ripple(props: RippleProps) {
  const {
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout,
    classes,
    className,
  } = props
  const [leaving, setLeaving] = React.useState(false)

  const rippleClassName = clsx(
    className,
    classes?.ripple,
    classes?.rippleVisible,
    pulsate && classes?.ripplePulsate
  )

  const childClassName = clsx(
    classes?.child,
    leaving && [classes?.childLeaving],
    pulsate && [classes?.childPulsate]
  )

  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX,
  }

  if (!inProp && !leaving) {
    setLeaving(true)
  }
  React.useEffect(() => {
    if (!inProp && onExited != null) {
      const timeoutId = setTimeout(onExited, timeout)
      return () => {
        clearTimeout(timeoutId)
      }
    }
    return undefined
  }, [onExited, inProp, timeout])

  return (
    <span className={rippleClassName} style={rippleStyles}>
      <span className={childClassName}></span>
    </span>
  )
}
